const TWILIO_ERROR_CODES: Record<string, string> = {
  "30001": "Queue overflow: the message waited too long and was not sent.",
  "30002": "Account suspended.",
  "30003":
    "Unreachable destination handset (off, out of coverage, or not a phone).",
  "30004": "Message blocked (by the carrier or the recipient).",
  "30005": "Unknown destination handset (number does not exist or is retired).",
  "30006": "Landline or unreachable carrier.",
  "30007": "Message filtered: flagged as spam or a carrier policy violation.",
  "30008": "Unknown delivery error reported by the carrier.",
  "30009": "A message segment is missing; the message was not fully delivered.",
  "30010": "Message price exceeded the configured maximum price.",
  "30034":
    "US A2P 10DLC: the sending number is not registered for this traffic.",
  "21211": "Invalid 'To' phone number.",
  "21408": "Permission to send to this region is not enabled on the account.",
  "21610": "Recipient has opted out (replied STOP); sending is blocked.",
  "21612": "The number cannot be routed to.",
  "21614": "'To' is not a valid mobile number.",
  "21617": "Message body exceeds the maximum length.",
  "63003": "Recipient is not reachable on WhatsApp.",
  "63005": "The sender is blocked by the recipient.",
  "63007": "No WhatsApp sender found for this number (not registered).",
  "63013": "Message blocked by a WhatsApp policy.",
  "63016": "Outside the 24-hour window: an approved template is required.",
  "63018": "WhatsApp rate limit reached for this sender.",
  "63021": "Invalid message parameters.",
  "63024": "Invalid template or template parameters.",
};

export const describeTwilioError = (
  code: string | number | null | undefined,
  errorMessage?: string | null
): string => {
  if (errorMessage) return errorMessage;
  if (code === null || code === undefined || code === "") return "";
  const key = String(code);
  return (
    TWILIO_ERROR_CODES[key] ||
    `Twilio error ${key} — see Twilio's error reference for details.`
  );
};

export default TWILIO_ERROR_CODES;
